import { render } from "./PaginationBox.vue?vue&type=template&id=6b998074"
import script from "./PaginationBox.vue?vue&type=script&lang=js"
export * from "./PaginationBox.vue?vue&type=script&lang=js"

import "./PaginationBox.vue?vue&type=style&index=0&id=6b998074&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__